// extracted by mini-css-extract-plugin
module.exports = {"hidden":"challengeBanner_hidden__IUk1J","textEmphasis":"challengeBanner_textEmphasis__Fn5RW","bannerArea":"challengeBanner_bannerArea__QZNc8","link":"challengeBanner_link__Ykv9r"};